import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";

/**
 * Creates a new category in the backend.
 *
 * @param {Object} categoryData
 * @returns {Promise<Object>}
 */
const createCategory = async (categoryData) => {
  return apiCall(AUTH_ROUTES.CATEGORIES_API_ENDPOINT, {
    method: "POST",
    body: categoryData,
  });
};

export default createCategory;
